import isEmail from 'validator/lib/isEmail'

export const isValidEmail = (email) => isEmail(email)
